const skill_improvise = [
    'Ablenken',
    'Aufmerksamkeit',
    'Bestechung',
    'Etikette',
    'Feilschen',
    'Flirten',
    'Forschen',
    'Hieb Ausweichen',
    'Klettern',
    'Konversation',
    'Nahkampfwaffen',
    'Projektilwaffen',
    'Schuld Abwälzen',
    'Schwimmen',
    'Spurenlesen',
    'Starrsinn',
    'Tierbeherrschung',
    'Verführen',
    'Waffenloser Kampf',
    'Wildnisüberleben',
    'Wurfwaffen'
]

export default skill_improvise